import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import { SEARCH_DATA_KEY } from 'api/search'
import axios from 'axios'
export interface BatchReplaceItem {
  tableName: string
  PK: string
  SK: string
  newItem: Record<string, any>
}

export interface ReplaceItemsPayload {
  updates: BatchReplaceItem[]
}

export const replaceItems = async ({ updates }: ReplaceItemsPayload): Promise<any> => {
  console.log('[replaceItems] called with updates: ', updates)
  const url = `${baseUrl}/aws/update/replace-items`
  try {
    const response = await axios.put(url, { updates })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update items:', error)
    throw error
  }
}

export const useReplaceItems = () => {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, ReplaceItemsPayload>({
    mutationFn: replaceItems,
    onSuccess: (data, variables) => {
      console.log('[useReplaceItems] Updated items data:', data, 'VARIABLES: ', variables)

      // Merge replaced items into SEARCH_DATA_KEY cache
      const updates = variables.updates ?? []
      if (updates.length > 0) {
        const patchByKey = new Map(updates.map(u => [`${u.PK}::${u.SK}`, u.newItem]))
        const affectedPKs = new Set(updates.map(u => u.PK))

        queryClient.setQueryData(SEARCH_DATA_KEY, (old: any) => {
          if (!old) return old
          const patchList = (arr: any[]) =>
            Array.isArray(arr)
              ? arr.map(item => {
                  const patch = patchByKey.get(`${item.PK}::${item.SK}`)
                  return patch ? { ...item, ...patch } : item
                })
              : arr
          return {
            ...old,
            deals: patchList(old.deals),
            organizations: patchList(old.organizations),
            products: patchList(old.products),
          }
        })

        // Invalidate org-level caches for affected PKs
        affectedPKs.forEach(pk => {
          queryClient.invalidateQueries({ queryKey: ['all_org_items', pk] })
        })
      }
    },
    onError: error => {
      console.error('[useReplaceItems] Error updating items:', error)
    },
  })
}
